const initialState = {};
export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case "VALIDATE_TOKEN":
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
}
